import { ImageModel } from './image-model';

export interface Hero {
    type: string;
    images: ImageModel[];
    mediaId: number | null;
}
